/**
 * @file       Navigation guards module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";

/**
 * Navigation guard if authenticated.
 *
 * @param   {Object}     to          Unused parameter
 * @param   {Object}     from        Unused parameter
 * @param   {function}   next        Destination
 */
export function ifAuthenticated(to, from, next) {
  const refreshToken = localStorage.getItem("refresh-token");
  const accessToken = localStorage.getItem("access-token");

  if (!store.state.auth.profile.data && refreshToken && accessToken) {
    store
      .dispatch("auth/checkToken")
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: "auth.login.options", query: { redirect: to.fullPath } });
      });
  } else if (store.state.auth.profile.data) {
    next();
  } else {
    next({ name: "auth.login.options", query: { redirect: to.fullPath } });
  }
}

/**
 * Navigation guard if admin.
 *
 * @param   {Object}     to          Unused parameter
 * @param   {Object}     from        Unused parameter
 * @param   {function}   next        Destination
 */
export function ifAdmin(to, from, next) {
  const user = store.state.auth.profile.data.data.find(u => u);
  user.role == "admin" ? next() : next("/");
}

/**
 * Navigation guard if teacher.
 *
 * @param   {Object}     to          Unused parameter
 * @param   {Object}     from        Unused parameter
 * @param   {function}   next        Destination
 */
export function ifTeacher(to, from, next) {
  const user = store.state.auth.profile.data.data.find(u => u);
  user.role == "teacher" ? next() : next("/");
}

/**
 * Navigation guard if student.
 *
 * @param   {Object}     to          Unused parameter
 * @param   {Object}     from        Unused parameter
 * @param   {function}   next        Destination
 */
export function ifStudent(to, from, next) {
  const user = store.state.auth.profile.data.data.find(u => u);
  ["student", "guest"].includes(user.role) ? next() : next("/");
}
